"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { FlexColumn, Table } from "@opensea/ui-kit";
import { ItemPreviewTooltipTraitTableFragment } from "./ItemPreviewTooltipTraitTable.fragment";
import { ItemPreviewTooltipTraitTableHeader } from "./ItemPreviewTooltipTraitTableHeader";
import { ItemPreviewTooltipTraitTableRow } from "./ItemPreviewTooltipTraitTableRow";
import { MAX_TRAITS } from "./utils";
export function ItemPreviewTooltipTraitTable(t0) {
  const $ = _c(18);
  const {
    item: itemKey
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== itemKey) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const item = readFragment(ItemPreviewTooltipTraitTableFragment, itemKey);
      if (!item.attributes) {
        t5 = undefined;
        break bb0;
      }
      T1 = FlexColumn;
      t4 = "w-full overflow-hidden";
      T0 = Table;
      if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = <ItemPreviewTooltipTraitTableHeader />;
        $[8] = t1;
      } else {
        t1 = $[8];
      }
      t2 = _temp;
      t3 = item.attributes.slice(0, MAX_TRAITS);
    }
    $[0] = itemKey;
    $[1] = T0;
    $[2] = T1;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    T0 = $[1];
    T1 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[9] !== T0 || $[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t6 = <T0 header={t1} itemKey={t2} items={t3} renderRow={ItemPreviewTooltipTraitTableRow} size="xs" />;
    $[9] = T0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== T1 || $[15] !== t4 || $[16] !== t6) {
    t7 = <T1 className={t4}>{t6}</T1>;
    $[14] = T1;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp(_, index) {
  return index;
}